import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { HttpService } from '../http/http.service';
import { jwtDecode } from 'jwt-decode';

interface JwtPayload {
  exp: number;
  UserRoleName: string;
  WarehouseId: string;
  BranchId: string;
  Branch: string;
  Warehouse: string;
  Name: string;
  UserId: string;
}

const TOKEN_KEY = 'token';
const REFRESH_TOKEN_KEY = 'refreshToken';
const REFRESH_TOKEN_URL = 'https://erpsaapi.skyttus.in/api/Auth/checkToken';

@Injectable()
export class AuthService {
  private accessToken = localStorage.getItem(TOKEN_KEY) ?? '';
  private refreshToken = localStorage.getItem(REFRESH_TOKEN_KEY) ?? '';

  constructor(private http: HttpService) {}

  getAccessToken(): string {
    return this.accessToken;
  }

  setAccessToken(token: string): void {
    this.accessToken = token;
  }

  getRefreshToken(): string {
    return this.refreshToken;
  }

  setRefreshToken(token: string): void {
    this.refreshToken = token;
  }

  isTokenExpired(token: string): boolean {
    if (!token || token.split('.').length !== 3) return true;
    try {
      const { exp } = jwtDecode<JwtPayload>(token);
      return Date.now() >= exp * 1000;
    } catch {
      return true;
    }
  }

  refreshTokenCall(): Observable<any> {
    return this.http.post(REFRESH_TOKEN_URL, {
      accessToken: this.accessToken,
      refreshToken: this.refreshToken
    }).pipe(
      tap(response => {
        this.accessToken = response.token;
        this.refreshToken = response.refreshToken;
        localStorage.setItem(TOKEN_KEY, response.token);
        localStorage.setItem(REFRESH_TOKEN_KEY, response.refreshToken);
      })
    );
  }

  getUserInfo(): JwtPayload {
    return jwtDecode<JwtPayload>(this.accessToken);
  }

  getRoleName(): string {
    return this.getUserInfo().UserRoleName;
  }

  startAutoLogoutTimer(): void {
    const midnight = new Date();
    midnight.setHours(24, 0, 0, 0);
    const delay = midnight.getTime() - Date.now();

    setTimeout(() => {
      this.logout();
      window.location.href = '/auth/signin';
    }, delay);
  }

  logout(): void {
    [TOKEN_KEY, REFRESH_TOKEN_KEY, 'moduleList', 'userId', 'userTypeId', 'previouseurl']
      .forEach(key => localStorage.removeItem(key));
    this.accessToken = '';
    this.refreshToken = '';
  }
}